var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHighRiseBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 21v-17l1.06581e-14 1.50996e-07c-8.33927e-08-.552285.447715-1 1-1h6l-4.37114e-08 8.88178e-16c.552285-2.41411e-08 1 .447715 1 1v17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21v-13.087h3.55271e-15c0-.504236-.408764-.913-.913-.913 0 0 0 0 0 0h-4.087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7h-4.087l-3.99085e-08 8.88178e-16c-.504236 2.20409e-08-.913.408764-.913.913 0 0 0 8.88178e-16 0 8.88178e-16v13.087"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    x2: 18.5,
    y1: 10,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    x2: 18.5,
    y1: 13,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    x2: 18.5,
    y1: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    x2: 8,
    y1: 10,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    x2: 8,
    y1: 13,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    x2: 8,
    y1: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    x2: 13.5,
    y1: 13,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    x2: 13.5,
    y1: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    x2: 13.5,
    y1: 10,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    x2: 13.5,
    y1: 7,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    x2: 12,
    y1: 19,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    x2: 2,
    y1: 21,
    y2: 21
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRiseBuilding);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "static/media/high-rise-building.071952505257f70205975c5f95a4626e.svg";
export { MemoForwardRef as ReactComponent };